import React from "react";

import { ISelectDropdownOption } from "../interfaces/form_elements";

interface IChangeSelectProps {
    read_only: boolean | undefined;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onChange: (option: ISelectDropdownOption) => void;
    option: ISelectDropdownOption;
};
export const onChangeSelect = (props: IChangeSelectProps) => {
    const { read_only, setOpen, onChange, option } = props;

    if (read_only) return;
    setOpen(false);
    onChange(option);
};